var map = {
	"./banner-btc-mobile.png": 25142,
	"./banner-btc.png": 59561,
	"./banner-eth-mobile.png": 20217,
	"./banner-eth.png": 75548,
	"./banner-eth@2x.png": 71054,
	"./banner-eth@3x.png": 51572,
	"./banner-matic-mobile.png": 25971,
	"./banner-matic.png": 18800,
	"./bg-winner.png": 40583,
	"./btc.png": 81167,
	"./eth.png": 28468,
	"./even-odd.png": 15120,
	"./high-low.png": 10127,
	"./matic.png": 38611,
	"./title-lets-play.png": 32433,
	"./title.png": 53850,
	"./title@2x.png": 30865,
	"./title@3x.png": 64959,
	"./up-down.png": 67799,
	"./usdt.png": 22937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30193;